<template>
  <div>
    <section class="orep-header mont" v-if="$route.name !== 'home-inspector-final' && $route.name !== 'home-inspector-representation'">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'IBD'" src="../../../public/assets/images/ibdpro-logo.svg" class="logo-ibdpro" alt="Logo">
        <img v-else-if="getApplicantType === 'RWS'" src="../../../public/assets/images/rws-logo.svg" class="logo-ibdpro" alt="Logo">
        <img v-else-if="getApplicantType === 'SPMGA'" src="../../../public/assets/images/spmga-logo.svg" class="logo-spmga" alt="Logo">
        <img v-else-if="getApplicantType === 'RISKPRO'" src="../../../public/assets/images/riskpro-logo.svg" class="logo-riskpro" alt="Logo">
        <img v-else src="../../../public/assets/images/OREPInsuranceShield_new.png" class="logo" alt="Logo">
        <span v-if="getApplicantType === 'OREP'" class="logo-text text-uppercase">CALIF. LIC. #0K99465</span>

      </section>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "home-inspector",
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      state() {
        return this.$store.state.homeInspector;
      },
      errorMsg() {
        return this.$store.state.homeInspector.errorMsg;
      },

      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/home-inspector-ibd/' || first === '/portal/home-inspector-IBD/'|| this.quote.customer.partnerName === 'IBD'){
          return 'IBD';
        }else if (first === '/portal/home-inspector-rws/' || first === '/portal/home-inspector-rws/'|| this.quote.customer.partnerName === 'RWS'){
          return 'RWS';
        }else if (first === '/portal/home-inspector-spmga/' || first === '/portal/home-inspector-spmga/'|| this.quote.customer.partnerName === 'SPMGA'){
          return 'SPMGA';
        }
        else if (first === '/portal/home-inspector-new/' || first === '/portal/home-inspector-NEW/'|| this.quote.customer.partnerName === 'NEW'){
          return 'NEW';
        }
        else if (first === '/riskpro/home-inspector/' || first === '/RISKPRO/home-inspector/' ||this.quote.customer.partnerName === 'RISKPRO'){
          return 'RISKPRO';
        }
        else {
          return 'OREP';
        }
      },
    },
    data() {
      return {
        isActive: false
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
